class CaretString {
  constructor(string, caretPosition, caretGravity) {
    this.string = string;
    this.caretPosition = caretPosition;
    this.caretGravity = caretGravity;
  }
  reversed() {
    return new CaretString(this.string.split("").reverse().join(""), this.string.length - this.caretPosition, this.caretGravity);
  }
}
export default CaretString;
//# sourceMappingURL=CaretString.js.map